import React, {
  createContext,
  useState,
  useMemo,
  useContext,
  useEffect,
} from "react";
import PropTypes from "prop-types";
import {
  menuItemsData,
  menuItemsDataCustomer,
  menuItemsDataWitron,
} from "../modules/menu/menuItemsData";
import { UserContext } from "./UserContext";
import { connectStreamDeckHelper, subscribeStreamDeckKeys, updateStreamDeckState } from "../interface/StreamdeckConnection";
import { useLocation, useNavigate } from "react-router-dom";
import { filterMenu } from "../modules/menu/menuFilter";
import { currentLocationConfig } from "../config/locationRegistry";

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const { userDetails } = useContext(UserContext);
   const location = useLocation(); //✅ Stream deck functionality
  const [menuItems, setMenuItems] = useState(menuItemsDataCustomer); // Set customer as default
  const [secondaryMenu, setSecondaryMenu] = useState({ title: "", items: [] });
  const [pageTitle, setPageTitle] = useState("Menu");
  const navigate = useNavigate();

  // ✅ Reactively update menu when userDetails changes
  // useEffect(() => {
  //   if (userDetails?.userCompany === "Witron") {
  //     setMenuItems(menuItemsDataWitron);
  //   } else {
  //     setMenuItems(menuItemsDataCustomer);
  //   }
  // }, [userDetails]);

  
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const filteredMenu = filterMenu(menuItemsData, {
      company: userDetails?.userCompany,
      isMobile,
      features: currentLocationConfig.features,
    });
    setMenuItems(filteredMenu);
  }, [userDetails]);

  const replaceMenuItems = (newItems) => {
    setMenuItems(newItems);
  };

  const updateSecondaryMenu = (menuData) => {
    setSecondaryMenu(menuData);
  };

  const updatePageTitle = (newTitle) => {
    setPageTitle(newTitle);
  };

  const contextValue = useMemo(
    () => ({
      menuItems,
      replaceMenuItems,
      secondaryMenu,
      updateSecondaryMenu,
      pageTitle,
      updatePageTitle,
    }),
    [menuItems, secondaryMenu, pageTitle]
  );

  // ───────────── Stream Deck Component ─────────────

useEffect(() => {
  connectStreamDeckHelper();
}, []);

useEffect(() => {
  const path = location.pathname.replace("/", "") || "home";
  const params = new URLSearchParams(location.search);

  if (path === "machinefaults") {
    const selectedTeam = params.get("team") || "AllTeams";
    const selectedTimePeriod = params.get("timeperiod") || "Week";

    console.log("[StreamDeck] sending machinefaults state", {
      page: "machinefaults",
      selectedTeam,
      selectedTimePeriod,
    });

    updateStreamDeckState({
      page: "machinefaults",
      selectedTeam,
      selectedTimePeriod,
    });

    return;
  }

  console.log("[StreamDeck] sending page state", { page: path });

  updateStreamDeckState({
    page: path,
  });
}, [location.pathname, location.search]);

useEffect(() => {
  const unsubscribe = subscribeStreamDeckKeys((key) => {
    console.log("Stream Deck key pressed:", key);

    // Global navigation
    if (key === 1) navigate("/dashboard");
    if (key === 2) navigate("/machinefaults");
    if (key === 3) navigate("/maintenance?page=plannedCR");
    if (key === 4) navigate("/yggdrasil");

    // Machine Faults context actions
    if (location.pathname.startsWith("/machinefaults")) {
      const params = new URLSearchParams(location.search);

      const currentTeam = params.get("team") || "AllTeams";
      const currentTimePeriod = params.get("timeperiod") || "Week";

      const goMachineFaults = ({ team, timeperiod }) => {
        const nextTeam = team || currentTeam;
        const nextTimePeriod = timeperiod || currentTimePeriod;

        navigate(
          `/machinefaults?timeperiod=${nextTimePeriod}&team=${nextTeam}`
        );
      };

      // Row 2 — Team
      if (key === 6) goMachineFaults({ team: "AllTeams" });
      if (key === 7) goMachineFaults({ team: "Shift1" });
      if (key === 8) goMachineFaults({ team: "Shift2" });
      if (key === 9) goMachineFaults({ team: "Shift3" });

      // Row 3 — Time Period
      if (key === 11) goMachineFaults({ timeperiod: "Day" });
      if (key === 12) goMachineFaults({ timeperiod: "Week" });
      if (key === 13) goMachineFaults({ timeperiod: "Month" });
    }
  });

  return unsubscribe;
}, [navigate, location.pathname, location.search]);

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

NavigationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavigationProvider;
